"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const BaseClass_1 = __importDefault(require("./BaseClass"));
/**
 * Class Service Member contain function to manage member of services
 * @public
 */
class ServiceMember extends BaseClass_1.default {
    constructor(apiV1, apiV2) {
        super(apiV1, apiV2);
    }
    /**
     * Get list member of service
     * @param serviceId - service Id
     * @returns list of members in service
     */
    async getListMember(serviceId) {
        try {
            const data = await this._apiV2.memberAPI.getListMember(serviceId);
            return data;
        }
        catch (error) {
            this._handleError(error);
        }
    }
    /**
     * Invite member to service
     * @param serviceId - service Id
     * @param payload - invite member payload. E.g: {userEmail:"a@b.com",serviceRole:"owner"}
     * @returns empty result
     */
    async inviteMember(serviceId, payload) {
        try {
            const data = await this._apiV2.memberAPI.inviteMember(serviceId, payload);
            return data;
        }
        catch (error) {
            this._handleError(error);
        }
    }
    /**
     * Resend member invite
     * @param serviceId - service Id
     * @param inviteId - invite Id
     * @returns empty result
     */
    async resendInvite(serviceId, inviteId) {
        try {
            const data = await this._apiV2.memberAPI.resendInvite(serviceId, inviteId);
            return data;
        }
        catch (error) {
            this._handleError(error);
        }
    }
    /**
     * Remove sent invite
     * @param serviceId - service Id
     * @param inviteId - invite id
     * @returns empty result
     */
    async removeInvite(serviceId, inviteId) {
        try {
            const data = await this._apiV2.memberAPI.removeInvite(serviceId, inviteId);
            return data;
        }
        catch (error) {
            this._handleError(error);
        }
    }
    /**
     * Update role of a member in service
     * @param serviceId - service Id
     * @param payload - update member payload. E.g: {userId:"123",serviceRole:"owner"}
     * @returns returned updated data
     */
    async updateMember(serviceId, payload) {
        try {
            const data = await this._apiV2.memberAPI.updateMemberRole(serviceId, {
                memberId: payload.userId,
                role: payload.serviceRole,
            });
            return data;
        }
        catch (error) {
            this._handleError(error);
        }
    }
    /**
     * Remove a member in service
     * @param serviceId - service Id
     * @param payload - remove member payload. E.g: {userId: "123", serviceRole: "owner"}
     * @returns return empty response
     */
    async removeMember(serviceId, payload) {
        try {
            const data = await this._apiV2.memberAPI.removeMember(serviceId, {
                memberId: payload.userId,
                role: payload.serviceRole,
            });
            return data;
        }
        catch (error) {
            this._handleError(error);
        }
    }
}
exports.default = ServiceMember;
